<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="openAddDialog">新增</el-button>
    </div>

    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <!-- <el-table-column sl></el-table-column> -->
      <el-table-column
        slot="filter"
        label="图片"
        align="center">
        <template slot-scope="scope">
          <img
            :src="qiniuDomain + scope.row.style_img"
            style="max-width: 150px; max-height:100px;">
        </template>
      </el-table-column>
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="285"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="success"
              plain
              @click="toDetail(scope.row.uuid)">详情</el-button>
            <el-button
              type="primary"
              plain
              @click="handlerEdit(scope)">编辑</el-button>
            <el-button
              type="danger"
              plain
              @click="handlerDel(scope)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>

    <el-dialog
      :title="dialogType==0? '新增': '编辑'"
      :visible.sync="dialogEdit"
      width="500px">

      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="editObject.style_title"/>
        </el-form-item>
        <el-form-item label="英文标题">
          <el-input v-model="editObject.style_english_title"/>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editObject.style_desc"/>
        </el-form-item>
        <el-form-item label="英文描述">
          <el-input v-model="editObject.style_english_desc"/>
        </el-form-item>
        <el-form-item label="权重">
          <el-input-number
            v-model="editObject.style_sort"
            :min="1" />
            <!-- <el-input v-model="editObject.style_sort"/> -->
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadSuccess"
            :show-file-list="false">
            <img
              v-if="editObject.style_img"
              :src="qiniuDomain + editObject.style_img"
              class="avatar">
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item label="banner">
          <el-upload
            class="upload-demo"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadBannerSuccess"
            :show-file-list="false"
            list-type="picture">
            <el-button
              size="small"
              type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div
            v-for="(item, index) in editObject.banner"
            :key="index"
            class="banner-box">
            <span
              class="icon"
              @click="onRomoveBanner(index)">×</span>
            <img
              :src="qiniuDomain + item.style_carousel_img"
              class="banner-img" >
          </div>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSaveClick()">确 定</el-button>
      </span>
    </el-dialog>

  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  styleList, addStyle, editStyle, delStyle, styleDetail,
} from '@/api/style'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      dialogEdit: false,
      dialogType: 0, //  0-新增、1-编辑
      editObject: { //  根据接口来的命名，不是很喜欢---
        style_title: '',
        style_img: '',
        style_sort: '',
        style_desc: '',
        style_english_title: '',
        style_english_desc: '',
        banner: [],
        // uuid: '',
      },
      chooseUuid: '', //  本来是打算丢 editObject 对象了，发现编辑时参数里多了个uuid会报错
      config: {
        // pagination: true,
        size: 5,
        fields: [
          {
            prop: 'style_title',
            label: '标题',
          },
          {
            prop: 'style_desc',
            label: '描述',
          },
          {
            prop: 'style_english_title',
            label: '标题',
          },
          {
            prop: 'style_english_desc',
            label: '描述',
          },
          {
            prop: 'style_sort',
            label: '权重',
          },
        ],
      },
      datasource: {
        total: 1,
        data: [],
      },
      pageIndex: 1,
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().styleList()
  },
  methods: {
    toDetail(uuid) {
      this.$router.push({
        path: `/style-detail/${uuid}`,
      })
    },
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().styleList()
    },
    async handlerEdit(data) {
      this.chooseUuid = data.row.uuid
      this.dialogType = 1 // 编辑框
      // this.editObject.style_title = data.row.style_title
      // this.editObject.style_sort = data.row.style_sort
      // this.editObject.style_img = data.row.style_img
      // this.editObject.uuid = data.row.uuid
      // this.editObject.banner = data.row.banner || []
      // ====列表拿不到banner数据，只能调详情接口了====
      await this.network().styleDetail(data.row.uuid)
      this.dialogEdit = true
    },
    handlerDel(data) {
      this.network().delStyle(data.row.uuid)
    },
    openAddDialog() {
      this.dialogType = 0
      this.editObject.style_title = ''
      this.editObject.style_english_title = ''
      this.editObject.style_sort = ''
      this.editObject.style_img = ''
      this.editObject.style_desc = ''
      this.editObject.style_english_desc = ''
      this.editObject.banner = []
      this.dialogEdit = true
    },
    handlerNavigator(scope) {
      this.$router.push({
        path: `/example-management/example-${scope.row.alias}`,
      });
    },
    uploadSuccess(res) {
      this.editObject.style_img = res.hash
    },
    uploadBannerSuccess(res) {
      const oBanner = {
        style_carousel_img: res.hash,
      }
      this.editObject.banner.push(oBanner)
    },
    onRomoveBanner(index) {
      this.editObject.banner.splice(index, 1)
    },
    event() {
      return {
        onSaveClick: () => {
          if (!this.event().inputVerify()) return
          //  dialogType: 0-新增、1-编辑
          if (this.dialogType === 0) {
            this.network().addStyle()
          } else {
            this.network().editStyle()
          }
        },
        inputVerify: () => {
          if (!this.editObject.style_title) {
            this.$message('请填写标题')
            return false
          }
          if (!this.editObject.style_english_title) {
            this.$message('请填写英文标题')
            return false
          }
          if (!this.editObject.style_desc) {
            this.$message('请填写描述')
            return false
          }
          if (!this.editObject.style_english_desc) {
            this.$message('请填写英文描述')
            return false
          }
          if (!this.editObject.style_sort) {
            this.$message('请填写权重')
            return false
          }
          if (!this.editObject.style_img) {
            this.$message('请上传图片')
            return false
          }
          if (this.editObject.banner.length < 1) {
            this.$message('请上传banner')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        styleList: async () => {
          const { status, data } = await styleList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_count
            this.datasource.data = data.char
          }
        },
        addStyle: async () => {
          const { status } = await addStyle(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().styleList()
          }
        },
        editStyle: async () => {
          //  额分离uuid???
          const { status } = await editStyle(this.editObject, this.chooseUuid)
          if (status === 200) {
            this.dialogEdit = false
            this.network().styleList()
          }
        },
        delStyle: async (uuid) => {
          const { status } = await delStyle({
            uuid,
          })
          if (status === 200) {
            this.dialogEdit = false
            this.network().styleList()
          }
        },
        styleDetail: async (uuid) => {
          const { status, data } = await styleDetail({
            uuid,
          })
          if (status === 200) {
            this.editObject.style_title = data.style_title
            this.editObject.style_sort = data.style_sort
            this.editObject.style_img = data.style_img
            this.editObject.style_desc = data.style_desc
            this.editObject.style_english_desc = data.style_english_desc
            this.editObject.style_english_title = data.style_english_title
            // this.editObject.uuid = data.uuid
            // this.editObject.banner = data.banner || []
            const oBanner = []
            data.banner.forEach((item) => {
              oBanner.push({
                style_carousel_img: item.style_carousel_img,
              })
            })
            this.editObject.banner = oBanner
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/style/style-list.vue